export default function formatDate(isoDateString: string) {
    const date = new Date(isoDateString);
    const day = date.getUTCDate();
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    const monthIndex = date.getUTCMonth();
    const year = date.getUTCFullYear();
  
    return `${day} ${monthNames[monthIndex]} ${year}`;
  }
  
  